"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonGroup = _interopRequireDefault(require("../ButtonGroup"));

var _primitives = require("./primitives");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PayWithButtonGroup = function PayWithButtonGroup(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$locked = _ref.locked,
      locked = _ref$locked === void 0 ? false : _ref$locked,
      onChange = _ref.onChange,
      _ref$pointsPlusPayEna = _ref.pointsPlusPayEnabled,
      pointsPlusPayEnabled = _ref$pointsPlusPayEna === void 0 ? false : _ref$pointsPlusPayEna,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      value = _ref.value;
  var options = (pointsPlusPayEnabled ? _primitives.ALL_PAYWITH_OPTIONS : _primitives.DEFAULT_PAYWITH_OPTIONS).map(function (option) {
    return option.value === value ? option : _objectSpread(_objectSpread({}, option), {}, {
      disabled: locked
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
    disabled: disabled,
    name: "pay-with-button-group",
    onChange: onChange,
    options: options,
    size: size,
    value: value,
    variant: "primary",
    width: [1, 'auto']
  });
};

PayWithButtonGroup.propTypes = {
  pointsPlusPayEnabled: _propTypes["default"].bool,
  value: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  locked: _propTypes["default"].bool,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array])
};
var _default = PayWithButtonGroup;
exports["default"] = _default;